<template>
    <div id="content_editor_rte"></div>
</template>

<script>
import { toRefs, ref, onMounted, watch } from 'vue';
export default {
    props: {
        modelValue: { type: String, default: '', require: false },
        setContent: { type: String, default: '', require: false },
    },
    setup(props, { emit }) {
        const editorData = ref();
        const { modelValue, setContent } = toRefs(props);
        const editor = ref();

        onMounted(() => {
            // eslint-disable-next-line no-undef
            editor.value = new RichTextEditor('#content_editor_rte');
            editor.value.setHTMLCode(modelValue.value);
            editor.value.attachEvent('change', function () {
                editorData.value = editor.value.getHTMLCode();
            });
        });

        watch(setContent, (first, second) => {
            if (first !== second) {
                editor.value.setHTMLCode(setContent.value);
            }
        });

        watch(editorData, (currentValue, oldValue) => {
            if (currentValue !== oldValue) {
                emit('update:modelValue', currentValue);
            }
        });
    },
};
</script>
